export const reviews: Array<[string, string, string, string, string]> = [
  [
    'MG',
    'María G.',
    'Bibliotecaria · Escuela Técnica, Buenos Aires',
    'En una tarde tenía más material sobre gestión de biblioteca escolar contextualizado en Argentina que en toda mi carrera profesional. Ahora mis alumnos y colegas me preguntan sobre clasificación decimal, catalogación, promoción de lectura, alfabetización informacional, y tengo respuesta fundamentada para todo. El impacto es visible desde la primera semana.',
    'bg-deep',
  ],
  [
    'RT',
    'Rodrigo T.',
    'Docente de Bibliotecología · Instituto Superior, Santa Cruz',
    'Mis estudiantes por primera vez entendieron la diferencia entre una biblioteca tradicional y un espacio de aprendizaje inclusivo, y analizaron casos reales de bibliotecas comunitarias del interior argentino con marcos normativos vigentes. El nivel de participación en las clases se multiplicó.',
    'bg-petrol',
  ],
  [
    'SP',
    'Sandra P.',
    'Coordinadora de Biblioteca · Instituto de Formación, Córdoba',
    'Las simulaciones de proyectos de lectura con las plantillas del MEGAPACK son exactamente lo que necesitaba: presupuesto real, organismos argentinos, normativas IFLA actualizadas, estrategias de mediación de lectura. Cambió la forma en que planifico todo el año.',
    'bg-violet',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'FM',
    'Federico M.',
    'Buenos Aires · Megapack Bibliotecología',
    'Con el MEGAPACK, en una tarde tenía el marco conceptual completo para explicar por qué la biblioteca escolar es un derecho educativo, qué dice IFLA sobre el rol del bibliotecario en la formación de ciudadanos digitales, y por qué cada iniciativa de promoción de lectura existe porque alguien decidió que el acceso a los libros debe ser igual para todos. Mis alumnos empezaron a ver la bibliotecología como una responsabilidad social. Porque lo es.',
  ],
  [
    'RV',
    'Rosa V.',
    'Neuquén · Megapack Bibliotecología',
    'Cuando explicás que la biblioteca escolar no es solo un lugar con estantes de libros, sino un espacio de acceso equitativo a la información, formación de ciudadanía digital y defensa contra la desinformación, empieza un debate sobre ética informacional, responsabilidad profesional y derechos de los estudiantes que ninguna otra asignatura genera con esa profundidad.',
  ],
  [
    'GN',
    'Gabriela N.',
    'Santa Cruz · Megapack Bibliotecología',
    'Cuando mis alumnos descubren que Argentina tiene bibliotecas escolares que están transformando comunidades enteras, que son espacios de acceso igualitario a la tecnología en contextos de brecha digital, que la mediación de lectura de un bibliotecario puede cambiar la trayectoria educativa de un estudiante, empieza una conversación sobre el valor de lo comunitario que ningún libro de texto puede provocar.',
  ],
  [
    'AS',
    'Alejandro S.',
    'Río Negro · Megapack Bibliotecología',
    'Cerré la planificación anual en dos horas. Antes me llevaba semanas. Ahora tengo todo el año organizado con la normativa IFLA actualizada, 100 proyectos para elegir y adaptar, actividades para cada mes y evaluación de impacto integrada.',
  ],
  [
    'SM',
    'Sofía M.',
    'Mendoza · Megapack Bibliotecología',
    'Cuando les digo a mis alumnos que el bibliotecario que trabaja en una escuela rural de La Rioja está haciendo lo mismo que los curadores de los grandes centros de información del mundo: garantizando derechos de acceso, preservando patrimonio, educando ciudadanos digitales críticos y cambiando vidas con cada mediación de lectura, les estoy enseñando lo que significa la responsabilidad cultural e informacional en el mundo real.',
  ],
];
